import React, { useState, useEffect } from 'react'
import Container from '../../components/Container'
import { Icon } from '../../components/Layout'
import api from '../../api'
import Skeleton from 'react-loading-skeleton'
import './style.scss'
import Tutorial from '../../components/Tutorial'

function IntelligenceBoard() {

    const [load, setLoad] = useState(true)
    const [data, setData] = useState({
        status: "",
        dashboard: [],
        smart_cards: [],
        priority: {
            today: "",
            week: "",
            month: ""
        }
    })

    const [runTutorial, setRunTutorial] = useState(false)

    useEffect(() => {
        const tutorialDone = localStorage.getItem('@amb:tutorialIntelligenceDone')
        if (!tutorialDone) {
            setRunTutorial(true)
        }
    }, [])

    const handleTutorialFinish = () => {
        localStorage.setItem('@amb:tutorialIntelligenceDone', 'true')
        setRunTutorial(false)
    }

    const tutorialSteps = [
        {
            target: 'body',
            content: 'Bem-vindo ao Intelligence Board! Aqui a IA analisa seus dados e sugere ações estratégicas.',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.callout-block',
            content: 'Visualize o status geral da sua conformidade ambiental em tempo real.',
            placement: 'bottom',
        },
        {
            target: '.smart-cards-section',
            content: 'Cards inteligentes com insights, riscos e decisões sugeridas para suas condicionantes.',
            placement: 'right',
        },
        {
            target: '.urgency-dashboard',
            content: 'Resumo de urgência com itens que precisam de atenção imediata.',
            placement: 'left',
        },
        {
            target: '.priority-schedule',
            content: 'Cronograma de ações prioritárias para hoje, esta semana e este mês.',
            placement: 'left',
        }
    ]

    useEffect(() => {
        getDados()
    }, [])

    async function getDados() {
        try {
            setLoad(true)
            const { data } = await api.get('ia/intelligence')

            setData(data)
            setLoad(false)
        } catch (error) {
            console.log(error)
            setLoad(false)
        }
    }

    function parseMetricSimple(text) {
        if (!text) return { label: '', rest: '' }
        const parts = text.split(':')
        const label = parts[0]
        const rest = parts.slice(1).join(':').trim()
        return { label, rest }
    }

    function getSoftColor(label) {
        if (!label) return 'bg-soft-success';
        const lowerLabel = label.toLowerCase();
        if (lowerLabel.includes('expirar') || lowerLabel.includes('crítica') || lowerLabel.includes('critica')) return 'bg-soft-warning';
        if (lowerLabel.includes('vencidas') || lowerLabel.includes('vencida') || lowerLabel.includes('imediato')) return 'bg-soft-danger';
        return 'bg-soft-success';
    }

    function getIcon(label) {
        if (!label) return 'ti-thumb-up';
        const lowerLabel = label.toLowerCase();
        if (lowerLabel.includes('expirar')) return 'ti-timer';
        if (lowerLabel.includes('vencidas') || lowerLabel.includes('vencida') || lowerLabel.includes('imediato')) return 'ti-alert';
        if (lowerLabel.includes('crítica') || lowerLabel.includes('critica')) return 'ti-calendar';
        return 'ti-thumb-up';
    }

    return (
        <Container
            title="Intelligence Board"
            titlesub="ANÁLISE ESTRATÉGICA"
            noCard
        >
            <Tutorial
                steps={tutorialSteps}
                run={runTutorial}
                onFinish={handleTutorialFinish}
            />
            <div className="smart-report-content">

                <div className="row" style={{ alignItems: 'flex-start' }}>
                    <div className="col-lg-7">
                        {
                            load ?
                                <div className="callout-block" style={{ borderLeft: '4px solid var(--color-border)' }}>
                                    <Skeleton height={20} width={`90%`} />
                                </div>
                                :
                                data.status && (
                                    <div className="callout-block attention">
                                        <Icon name="ti-info-alt" className="icon" style={{ color: '#EB5757' }} />
                                        <span>{data.status}</span>
                                    </div>
                                )
                        }

                        <div className="section-block mt-4 smart-cards-section">
                            <div className="section-title">
                                <span>Tomada de Decisão</span>
                            </div>
                            <div>
                                {
                                    load ?
                                        <>
                                            {[1, 2].map(i => (
                                                <div key={i} className="mb-4">
                                                    <div className={`insight-card`}>
                                                        <div className="card-content">
                                                            <div className="card-header-row mb-3">
                                                                <Skeleton width={200} height={24} />
                                                                <Skeleton width={80} height={24} />
                                                            </div>

                                                            <div className="card-target mb-3">
                                                                <Skeleton width={300} height={18} />
                                                            </div>

                                                            <div className="info-group mb-3">
                                                                <Skeleton width={60} height={14} className="mb-1" />
                                                                <Skeleton count={2} />
                                                            </div>

                                                            <div className="info-group mb-3">
                                                                <Skeleton width={60} height={14} className="mb-1" />
                                                                <Skeleton count={2} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                        :
                                        data.smart_cards.map((card, index) => (
                                            <div key={index} className="mb-4">
                                                <div className={`insight-card ${card.type}`} style={{ borderLeftColor: card.urgencyColor }}>
                                                    <div className="card-content">
                                                        <div className="card-header-row">
                                                            <h3>{card.title}</h3>
                                                            <div className={`tag ${card.type}`}>{card.tag}</div>
                                                        </div>

                                                        <div className="card-target">
                                                            <Icon name="ti-location-pin" className="icon" />
                                                            {card.target}
                                                        </div>

                                                        <div className="info-group">
                                                            <label>Situação</label>
                                                            <p>{card.situation}</p>
                                                        </div>

                                                        {card.risk && (
                                                            <div className="info-group">
                                                                <label style={{ color: '#EB5757' }}>{card.risk_label || 'Risco'}</label>
                                                                <p>{card.risk}</p>
                                                            </div>
                                                        )}

                                                        {card.insight && (
                                                            <div className="info-group">
                                                                <label style={{ color: '#2E7CF6' }}>Insight</label>
                                                                <p>{card.insight}</p>
                                                            </div>
                                                        )}

                                                        <div className="info-group suggestion">
                                                            <label>Decisão Sugerida:</label>
                                                            <p>{card.decision}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5" style={{ position: 'sticky', top: '24px' }}>
                        <div className="section-block urgency-dashboard">
                            <div className="priority-card">
                                <div className="card-header" style={{
                                    padding: '24px 24px 16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <Icon name="ti-alert" style={{ color: 'var(--color-text-primary)', fontSize: '20px' }} />
                                    <span style={{ fontSize: '18px', fontWeight: '700', color: 'var(--color-text-primary)' }}>Dashboard de Urgência</span>
                                </div>
                                {
                                    load ?
                                        <div style={{ padding: '24px' }}>
                                            {[1, 2, 3, 4].map(i => (
                                                <div key={i} className="mb-3" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                                    <Skeleton circle height={40} width={40} />
                                                    <div style={{ flex: 1 }}>
                                                        <Skeleton width={`60%`} height={16} />
                                                        <Skeleton width={`90%`} height={12} style={{ marginTop: 4 }} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        data.dashboard.map((item, index) => {
                                            const { label, rest } = parseMetricSimple(item)
                                            const softClass = getSoftColor(label);
                                            const icon = getIcon(label);

                                            if (rest === '0') return null;

                                            return (
                                                <div key={index} className="priority-row" style={{ alignItems: 'center' }}>
                                                    <div style={{ minWidth: '40px' }}>
                                                        <i className={`${icon} rounded-circle ${softClass}`} style={{ padding: '8px', fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
                                                    </div>
                                                    <div className="priority-text">
                                                        <div style={{ fontWeight: 700, color: 'var(--color-text-primary)', fontSize: '14px', lineHeight: '1.4' }}>{label}</div>
                                                        <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '4px' }} dangerouslySetInnerHTML={{ __html: rest }}></div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        </div>

                        <div className="section-block mt-4 priority-schedule">
                            <div className="priority-card">
                                <div className="card-header" style={{
                                    padding: '24px 24px 16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <Icon name="ti-calendar" style={{ color: 'var(--color-text-primary)', fontSize: '20px' }} />
                                    <span style={{ fontSize: '18px', fontWeight: '700', color: 'var(--color-text-primary)' }}>Cronograma de Ações Prioritárias</span>
                                </div>
                                {
                                    load ?
                                        <div style={{ padding: '24px' }}>
                                            {[1, 2, 3].map(i => (
                                                <div key={i} className="" style={{ marginBottom: '16px' }}>
                                                    <Skeleton width={100} height={20} style={{ marginBottom: 4 }} />
                                                    <Skeleton count={2} />
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <>
                                            <div className="priority-row">
                                                <div className="priority-tag"><span>Hoje</span></div>
                                                <div className="priority-text" dangerouslySetInnerHTML={{ __html: data.priority.today }}></div>
                                            </div>
                                            <div className="priority-row">
                                                <div className="priority-tag"><span>Esta Semana</span></div>
                                                <div className="priority-text" dangerouslySetInnerHTML={{ __html: data.priority.week }}></div>
                                            </div>
                                            <div className="priority-row">
                                                <div className="priority-tag"><span>Este Mês</span></div>
                                                <div className="priority-text" dangerouslySetInnerHTML={{ __html: data.priority.month }}></div>
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default IntelligenceBoard
